export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}form/question-tag`;

    return $resource(url, null, {});
};



// WEBPACK FOOTER //
// ./src/app/resources/QuestionTag/index.js